import React from 'react';

import Main from './Main';
import Footer from './Footer';

const Layout = () => {
    return (
        <>
        
        <Main />
        <Footer />
        </>
    );
};

export default Layout;